import React, {Component} from 'react';
import logo from '../Images/Chartichaut.png';
import '../App.css';
import Button from '@mui/material/Button';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { useNavigate } from "react-router-dom";

export default function Address() {

	let navigate = useNavigate(); 
  	const routeChange = () =>{ 
    	let path = 'geography'; 
   	 navigate(path);
 	 }

        return (
            <div className="App">
      		<header className="App-header">
        	<ThumbUpIcon sx={{ fontSize: 120 }}/>
            <div className="Content">
			Identité créée ! Vous êtes dorénavant inscrite à la vente aux enchères sous le nom de Kalia Akinara. <br/>
			La vente aura lieu au 12, rue Le Verrier, 75006 Paris, à 20h.
        </div>

      </header>
    </div>

        );
}